import { createSignal } from "solid-js";

const STORAGE_KEY = "vektor_message_sound";

function readInitial(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

const [messageSoundEnabled, setEnabledSig] = createSignal<boolean>(readInitial());

export { messageSoundEnabled };

export function setMessageSoundEnabled(enabled: boolean): void {
  setEnabledSig(enabled);
  try { localStorage.setItem(STORAGE_KEY, String(enabled)); } catch {}
  if (enabled) resumeCtx();
}

let audioCtx: AudioContext | null = null;
let unlockBound = false;

function getCtx(): AudioContext | null {
  if (typeof window === "undefined") return null;
  const Ctor = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  if (!audioCtx) audioCtx = new Ctor();
  return audioCtx;
}

function resumeCtx() {
  if (!messageSoundEnabled()) return;
  const ctx = getCtx();
  if (ctx && ctx.state === "suspended") void ctx.resume();
}

function bindUnlock() {
  if (unlockBound || typeof window === "undefined") return;
  unlockBound = true;
  window.addEventListener("pointerdown", resumeCtx, { passive: true });
  window.addEventListener("keydown", resumeCtx, { passive: true });
}

bindUnlock();

export function playMessageSound(): void {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === "suspended") void ctx.resume();

  const start = ctx.currentTime;
  const tone = (freq: number, offset: number, dur: number) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, start + offset);
    gain.gain.linearRampToValueAtTime(0.12, start + offset + 0.012);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + offset + dur);
    osc.connect(gain).connect(ctx.destination);
    osc.start(start + offset);
    osc.stop(start + offset + dur + 0.02);
  };
  tone(880, 0, 0.09);
  tone(1320, 0.085, 0.13);
}
